import {
    IHubBrandingDTO,
    IHubFooterDTO,
    IHubRegistrationDTO,
    IHubSignInDTO,
} from '../../../../../api/event-hubs.dao';
import { IHubRegistrationField } from '../../../../../api/hub-registration-configuration.dao';
import {
    HubPreviewRegistrationFieldExpectation,
    HubPreviewSyncExpectation,
} from './hub-preview-sync.types';

const getFieldConfiguration = (field: IHubRegistrationField) =>
    field.configurations[0] ?? { formName: '', mandatory: false, visible: false, order: 0 };

export const mapVisibleRegistrationFields = (
    fields: IHubRegistrationField[],
): HubPreviewRegistrationFieldExpectation[] =>
    fields
        .filter(field => getFieldConfiguration(field).visible)
        .map(field => ({
            fieldType: field.type,
            label: field.label.trim(),
            mandatory: getFieldConfiguration(field).mandatory,
            order: getFieldConfiguration(field).order,
        }))
        .sort((left, right) => left.order - right.order);

export const buildBrandingPreviewExpectation = (settings: IHubBrandingDTO): HubPreviewSyncExpectation => {
    const branding: HubPreviewSyncExpectation['branding'] = {
        primaryColor: settings.primaryColor ?? null,
        customCss: settings.customCss ?? null,
    };

    if (settings.logoImage != null) {
        branding.logoObjectKey = settings.logoImage.objectKey ?? '';
    }

    if (settings.backgroundImage != null) {
        branding.backgroundObjectKey = settings.backgroundImage.objectKey ?? '';
    }

    return { branding: branding };
};

export const buildRegistrationPreviewExpectation = (
    settings: IHubRegistrationDTO,
    fields: IHubRegistrationField[],
): HubPreviewSyncExpectation => ({
    registration: {
        registrationEnabled: settings.registrationEnabled,
        registrationDisplayName: settings.registrationDisplayName ?? null,
        registrationInstructions: settings.registrationInstructions ?? null,
        registerButtonLabel: settings.registerButtonLabel ?? null,
        registrationSubmittedMessage: settings.registrationSubmittedMessage ?? null,
    },
    registrationFields: mapVisibleRegistrationFields(fields),
});

export const buildFooterPreviewExpectation = (settings: IHubFooterDTO): HubPreviewSyncExpectation => ({
    footer: {
        footerText: settings.footerText ?? null,
        showWebsiteFooterLogoImage: settings.showWebsiteFooterLogoImage,
    },
});

export const buildSignInPreviewExpectation = (settings: IHubSignInDTO): HubPreviewSyncExpectation => ({
    signIn: {
        signInDisplayName: settings.signInDisplayName ?? null,
        requestLinkInstructions: settings.requestLinkInstructions ?? null,
        requestLinkButtonLabel: settings.requestLinkButtonLabel ?? null,
        signInLinkRequestedMessage: settings.signInLinkRequestedMessage ?? null,
    },
});
